import type { FaireProductEntity } from "../../entity_types/product";

export const p_ucgvzp8cyn: FaireProductEntity = {
  token: "p_ucgvzp8cyn",
  type: "product",
  name: "A Little Paper Hug Striped Thank You Card",
  brandToken: "b_qat8n5mmyf",
  brandName: "Willow & Ivy Press",
  imageUrl:
    "https://cdn.faire.com/fastly/ef322db9f715ecd8fd8472aad7d1399200d631d444b3dbc35b1e93d27cd8472f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d6bcfaf244be31aa3d24f1e2bf76fa9673741554358d0bb3918812626d6c9f1.png",
    "https://cdn.faire.com/fastly/e15e9bca99e6c126d074243906375b9445e6ad881edd4488238aecd49ded0100.jpeg",
  ],
  priceDollars: 18,
  description:
    'Sometimes the smallest gestures mean the most. This heartfelt design pairs a warm “a little paper hug” sentiment with a simple message of gratitude inside, making it a thoughtful way to thank friends, hosts, coworkers, teachers, and everyday kindness-makers. Finished with signature Willow & Ivy embellishments for a beautifully elevated touch.\n\nInside verse: thank you\n\n• Retail: $6.00 each\n• Wholesale: $18.00 per unit (6 cards + envelopes)\n• Card Size: 4 1/4" x 5 1/2" \n• Designed, printed & fulfilled in Mead, Colorado\n• Designed by our all-women team\n• Employee-owned & sustainably sourced\n• Heavyweight uncoated cardstock\n• Finished with gold foil, emboss & die-cut embellishments\n• Gold pearlized envelopes\n\nPlease note: Cards are not individually cello-wrapped and include the retail price printed on the back.',
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:21.857Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
